// src/utils/experienceLevels.js
export const EXPERIENCE_LEVELS = {
    NO_EXPERIENCE: 'No Experience Required',
    ZERO_TO_SIX_MONTHS: '0 - 6 Months',
    SIX_TO_TWELVE_MONTHS: '6 - 12 Months',
    ONE_TO_THREE_YEARS: '1 - 3 Years'
};

export const EXPERIENCE_LEVEL_OPTIONS = [
    { value: 'NO_EXPERIENCE', label: 'No Experience Required' },
    { value: 'ZERO_TO_SIX_MONTHS', label: '0 - 6 Months' },
    { value: 'SIX_TO_TWELVE_MONTHS', label: '6 - 12 Months' },
    { value: 'ONE_TO_THREE_YEARS', label: '1 - 3 Years' }
];

export const getExperienceLabel = (value) => {
    const option = EXPERIENCE_LEVEL_OPTIONS.find(opt => opt.value === value);
    return option ? option.label : value || 'Not specified';
};